<msc-common-nav [data]="nav"></msc-common-nav>
<section>
    <router-outlet></router-outlet>
</section>
